<template>
    <el-container id="container">
        <el-header v-bind:style="{'background': headerColor}">
            <content class="logo" style="justify-content: center;">                
                <a :href="ncutURL" target="_blank" style="position: absolute; left: 0;"><img src="../assets/images/logo0506.png" style="height: 3.45rem;" alt="NCUT勤益校徵圖示" title="NCUT Logo" /></a>
                <content>
                    <router-link class="app-title" to="/">{{(null == configData? appName:configData.sysTitle)}}</router-link>
                </content>
            </content>
        </el-header>
        <el-main>
            <slot></slot>
        </el-main>
        <el-footer
            v-bind:style="{'height':footerHeight, 'padding' : footerPadding}"        
            >
            &copy;{{`${new Date().getFullYear()}`}}
            <span style="padding-left: 2px;" 
                v-if="null == configData">國立勤益科技大學</span>
            <span v-else>
                <span style="padding-left: 2px;">
                    {{configData.shnm}}<br/>
                    地址：<a href="https://www.ncut.edu.tw/p/412-1000-253.php?Lang=zh-tw" style="line-height: normal;" target="blank">{{configData.shAdd}}</a><br/>
                    電話：{{configData.shFax}}
                </span>
            </span>
        </el-footer>
    </el-container>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import appNameMixin from '../appNameMixin';
    import {base} from '../constants';

    export default {
        name: 'LoginLayout',
        mixins: [appNameMixin],
        data: () => ({
            configData: null,
            base: base,
        }),
        computed:{
            ...mapState(['loading']),
            ...mapState('config', ['config']),
            headerColor () {
                return (this.configData!=null? this.configData.bgColor: '');
            },
            footerHeight () {
                return (this.configData!=null? '80px': '60px');
            },
            footerPadding () {
                return (this.configData!=null? '0.2rem 0': '');
            }
        },
        methods: {
            ...mapActions('config', {
                getConfig: 'getConfig'
            }),
        },
        watch: {
            config(current) {
                this.configData = {...current};
            }
        },
        async created() {
            await this.getConfig();
        }
    }
</script>

<style scoped>
    @import '../assets/styles/ncut.css';
    @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700,900&subset=chinese-traditional');

    #container {
        min-height: 100vh;
        background-color: #f0f2f5;
    }

    #container .el-header {
        background: #1867c0;
        padding-right: 15px;
    }

    #container .el-header .app-title {
        font-family: 'Noto Sans TC', sans-serif !important;
        line-height: 60px;
        font-size: 24px;
        color: white;
        text-decoration: none;
    }

    #container .el-main .content {

    }

    #container .el-footer {
        font-family: 'Noto Sans TC', sans-serif !important;
        text-align: center;
        background: #fff;
        color: #444;
    }

    #container .el-footer a {
        text-decoration: none;
        font-size: 14px;
        line-height: 60px;
    }

    .el-footer-conf {
        text-decoration: none;
        font-size: 14px;
        padding: 0.2rem 0;
        height: 80px;
    }
</style>
